<template>
  <svg
    class="copy"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3774 4612"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
  >
    <path
      d="M2708 4211l685-720h-685v720zm360-3865c0 63-51 115-115 115-63 0-115-51-115-115V230H229v3462h113c63 0 115 51 115 115 0 63-51 115-115 115H206c-57 0-108-23-145-60s-60-89-60-145V208c0-57 23-108 60-145S150 3 206 3h2657c56 0 108 23 145 60s60 88 60 145v140zm706 3053c0 52-35 97-83 110L2682 4570c-21 26-53 42-88 42H912c-57 0-108-23-145-60s-60-88-60-145V898c0-57 23-108 60-145s89-60 145-60h2657c56 0 108 23 145 60s60 88 60 145v2501zm-229-137V922H936v3462h1543V3377c0-63 51-115 115-115h951z"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'Copy',
};
</script>

<style scoped>
.copy {
  display: block;
}
</style>
